import { __decorate, __metadata } from "tslib";
import { elementDefine, onConnectedBodyShadow, onConnectedBefore, onConnectedAfter, onInitialize, addEventListener, innerHtml, attribute, } from '@dooboostore/simple-web-component';
import { Router } from '@dooboostore/core-web';
const tagName = 'center-math-page';
const CONCEPTS = [
    // 벡터 대수 기초
    { id: 'vector', label: '벡터', el: 'center-math-vector', group: 'vecbasic' },
    { id: 'dot', label: '내적', el: 'center-math-dot', group: 'vecbasic' },
    { id: 'norm', label: '노름', el: 'center-math-norm', group: 'vecbasic' },
    { id: 'normalize', label: '정규화', el: 'center-math-normalize', group: 'vecbasic' },
    { id: 'project', label: '정사영', el: 'center-math-project', group: 'vecbasic' },
    { id: 'cross', label: '외적·평면법선', el: 'center-math-cross', group: 'vecbasic' },
    { id: 'trig', label: '삼각함수', el: 'center-math-trig' },
    // 미분·적분
    { id: 'derivative', label: '미분', el: 'center-math-derivative', group: 'calculus' },
    { id: 'integral', label: '적분', el: 'center-math-integral', group: 'calculus' },
    // 회전·좌표변환
    { id: 'rotate', label: '회전', el: 'center-math-rotate', group: 'transform' },
    { id: 'translate', label: '병진(평행이동)', el: 'center-math-translate', group: 'transform' },
    { id: 'rotmatrix', label: '회전행렬', el: 'center-math-rotmatrix', group: 'transform' },
    { id: 'se3chain', label: 'SE(3) 좌표계 체인', el: 'center-math-se3chain', group: 'transform' },
    { id: 'rotcompare', label: '오일러·쿼터니언·Gram-Schmidt 비교', el: 'center-math-rot-compare', group: 'transform' },
    // 선형대수 심화
    { id: 'det', label: '행렬식(det)', el: 'center-math-det', group: 'linalg' },
    { id: 'rank', label: 'rank(상자)', el: 'center-math-rank', group: 'linalg' },
    { id: 'inverse', label: '역행렬·연립방정식(Ax=b)', el: 'center-math-inverse', group: 'linalg' },
    { id: 'eigen', label: '고유값·고유벡터', el: 'center-math-eigen', group: 'linalg' },
    { id: 'quadraticform', label: '이차형식·양의정부호', el: 'center-math-quadratic-form', group: 'linalg' },
    { id: 'jacobian', label: '자코비안·특이점', el: 'center-math-jacobian', group: 'linalg' },
    { id: 'pseudoinverse', label: '의사역행렬(DLS)', el: 'center-math-pseudoinverse', group: 'linalg' },
    { id: 'pca', label: 'PCA(주성분분석)', el: 'center-math-pca', group: 'linalg' },
    { id: 'leastsquares', label: '최소제곱법', el: 'center-math-least-squares', group: 'linalg' },
    { id: 'kabsch', label: 'Kabsch(점군 정렬)', el: 'center-math-kabsch', group: 'linalg' },
    { id: 'graph', label: '그래프·최단경로', el: 'center-math-graph' },
    { id: 'kalman', label: '칼만 필터', el: 'center-math-kalman' },
    // PID 튜닝(이론 → 실전 로봇코드)
    { id: 'pid', label: 'PID 제어', el: 'center-math-pid', group: 'pid' },
    { id: 'findgain', label: 'P게인 찾기(지연과 진동)', el: 'center-math-find-gain', group: 'pid' },
    { id: 'zieglernichols', label: 'Ziegler-Nichols 튜닝 공식', el: 'center-math-ziegler-nichols', group: 'pid' },
    { id: 'pidangle', label: 'PID 각도제어(실제 로봇코드)', el: 'center-math-pid-angle', group: 'pid' },
    // 제어이론 기초 어휘(루프·게인·근궤적)
    { id: 'loop', label: '개루프·폐루프', el: 'center-math-loop', group: 'ctrltheory' },
    { id: 'gain', label: '게인(이득)', el: 'center-math-gain', group: 'ctrltheory' },
    { id: 'rootlocus', label: '근궤적(Root Locus)', el: 'center-math-root-locus', group: 'ctrltheory' },
    // 수 체계(자연수→실수→허수→복소수)
    { id: 'naturalnumber', label: '자연수', el: 'center-math-naturalnumber', group: 'numbers' },
    { id: 'realnumber', label: '실수', el: 'center-math-realnumber', group: 'numbers' },
    { id: 'imaginarynumber', label: '허수', el: 'center-math-imaginarynumber', group: 'numbers' },
    { id: 'complex', label: '복소수', el: 'center-math-complex', group: 'numbers' },
    // 푸리에
    { id: 'fourier', label: '푸리에 변환', el: 'center-math-fourier', group: 'fourier' },
    { id: 'epicycle', label: '푸리에 원 애니메이션', el: 'center-math-epicycle', group: 'fourier' },
    // 자연상수 e
    { id: 'e', label: '자연상수 e (쉽게)', el: 'center-math-e', group: 'econst' },
    { id: 'econverge', label: '자연상수 e로 수렴', el: 'center-math-econverge', group: 'econst' },
    { id: 'euler', label: '오일러 공식(e^iθ)', el: 'center-math-euler', group: 'econst' },
    // 시스템 응답 특성(시정수·감쇠비·라플라스·PID의 관계)
    { id: 'timeconstant', label: '시정수(τ)', el: 'center-math-timeconstant', group: 'response' },
    { id: 'damping', label: '감쇠비·고유진동수(ζ,ωn)', el: 'center-math-damping', group: 'response' },
    { id: 'laplace', label: '라플라스 변환', el: 'center-math-laplace', group: 'response' },
    { id: 'controlmap', label: 'PID·라플라스·감쇠비·시정수 관계', el: 'center-math-controlmap', group: 'response' },
];
export default (w) => {
    var _a, _b;
    const existing = w.customElements.get(tagName);
    if (existing)
        return tagName;
    let MathPage = class MathPage extends w.HTMLElement {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "router", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "activeConcept", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'vector'
            });
        }
        setPageMeta() {
            return {
                titleBody: '수학 그래프 | @dooboostore',
                ogTitle: '수학 그래프 | @dooboostore',
                desc: '벡터·내적·노름을 그래프로 시각화해 보세요.',
                ogDesc: '벡터·내적·노름을 그래프로 시각화해 보세요.',
                ogImage: '/assets/images/math-og.png',
                twitterImage: '/assets/images/math-og.png',
                twitterTitle: '수학 그래프 | @dooboostore',
                twitterDesc: '벡터·내적·노름을 그래프로 시각화해 보세요.',
            };
        }
        onInit(router) {
            this.router = router;
            try {
                const c = router?.getSearchParams?.()?.get('concept');
                if (c && CONCEPTS.some(k => k.id === c))
                    this.activeConcept = c;
            }
            catch { }
        }
        onAfterConnected() {
            this.renderView();
        }
        onBack() { this.router.go('/'); }
        onConceptTab(e) {
            const btn = e.target.closest('.tab-concept');
            if (!btn || btn.dataset.value === this.activeConcept)
                return;
            this.activeConcept = btn.dataset.value;
            try {
                this.router?.replaceUpsertSearchParam?.({ concept: this.activeConcept });
            }
            catch { }
            this.syncTabs();
            this.renderView();
        }
        async onShareFab() {
            const url = this.ownerDocument.defaultView?.location.href ?? window.location.href;
            const fab = this.shadowRoot?.querySelector('#math-share-fab');
            const flash = () => {
                if (!fab)
                    return;
                fab.textContent = '✓';
                fab.classList.add('copied');
                setTimeout(() => { if (fab.textContent === '✓') {
                    fab.textContent = '🔗';
                    fab.classList.remove('copied');
                } }, 1500);
            };
            try {
                if (navigator.share) {
                    await navigator.share({ title: '수학 그래프 | @dooboostore', text: '수학 개념을 그래프로 확인해보세요!', url });
                }
                else {
                    await navigator.clipboard?.writeText(url);
                    flash();
                }
            }
            catch (err) {
                if (err?.name !== 'AbortError') {
                    try {
                        await navigator.clipboard?.writeText(url);
                        flash();
                    }
                    catch { }
                }
            }
        }
        syncTabs() {
            this.shadowRoot?.querySelectorAll('.tab-concept').forEach(el => el.classList.toggle('active', el.dataset.value === this.activeConcept));
        }
        /** 활성 개념 컴포넌트를 뷰 영역에 꽂음 — 각 컴포넌트가 자기 그래프를 직접 그림 */
        renderView() {
            const view = this.shadowRoot?.querySelector('#math-view');
            if (!view)
                return;
            const meta = CONCEPTS.find(k => k.id === this.activeConcept);
            view.innerHTML = `<${meta.el}></${meta.el}>`;
        }
        render() {
            const tabBtn = (c) => `<button class="tab tab-concept${c.id === this.activeConcept ? ' active' : ''}" data-value="${c.id}">${c.label}</button>`;
            let tabs = '';
            for (let i = 0; i < CONCEPTS.length;) {
                const g = CONCEPTS[i].group;
                if (g) {
                    let j = i;
                    while (j < CONCEPTS.length && CONCEPTS[j].group === g)
                        j++;
                    tabs += `<span class="tab-seg">${CONCEPTS.slice(i, j).map(tabBtn).join('')}</span>`;
                    i = j;
                }
                else {
                    tabs += tabBtn(CONCEPTS[i]);
                    i++;
                }
            }
            const meta = CONCEPTS.find(k => k.id === this.activeConcept);
            return `
        <style>
          :host { display:block; min-height:100vh; background:#f0f2f5; font-family:var(--font-family,sans-serif); }
          * { box-sizing:border-box; }
          .header { display:flex; align-items:center; gap:12px; padding:16px 20px; background:linear-gradient(135deg,#6366f1 0%,#8b5cf6 60%,#a78bfa 100%); color:#fff; }
          .header-back { background:rgba(255,255,255,0.2); border:none; color:#fff; width:38px; height:38px; border-radius:8px; cursor:pointer; display:flex; align-items:center; justify-content:center; font-size:18px; flex-shrink:0; }
          .header-back:hover { background:rgba(255,255,255,0.35); }
          .header-title { font-size:20px; font-weight:700; flex:1; }
          .header-hits { height:20px; border-radius:4px; opacity:0.9; margin-left:auto; }
          @media(max-width:600px){ .header{padding:12px 14px} .header-title{font-size:17px} }
          .content { padding:16px; display:flex; flex-direction:column; gap:12px; }
          @media(max-width:600px){ .content{padding:10px;gap:10px} }
          .card { background:#fff; border-radius:14px; box-shadow:0 4px 14px rgba(0,0,0,0.07); overflow:hidden; }
          .card-header { background:linear-gradient(135deg,#6366f1,#8b5cf6); color:#fff; padding:10px 14px; display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
          .card-title { font-size:14px; font-weight:700; }
          .card-body { padding:12px 14px; }
          .tab-group { display:flex; gap:6px; flex-wrap:wrap; }
          .tab { padding:5px 13px; border-radius:20px; border:1.5px solid #e2e8f0; background:#f8fafc; color:#64748b; font-size:12px; font-weight:600; cursor:pointer; transition:all .15s ease; white-space:nowrap; }
          .tab:hover { border-color:#94a3b8; color:#334155; }
          .tab.active { background:linear-gradient(135deg,#6366f1,#a78bfa); color:#fff; border-color:transparent; box-shadow:0 2px 8px rgba(99,102,241,0.3); }
          .tab-seg { display:inline-flex; flex-wrap:wrap; gap:5px; max-width:100%; padding:5px; border:1.5px dashed #cbd5e1; border-radius:16px; background:#eef2ff; }
          .tab-seg .tab { background:#fff; }
          .tab-seg .tab.active { background:linear-gradient(135deg,#6366f1,#a78bfa); color:#fff; border-color:transparent; }
          #math-view { padding:12px 14px; }
          .share-fab{position:fixed;bottom:24px;right:24px;width:54px;height:54px;border-radius:50%;background:linear-gradient(135deg,#6366f1,#a78bfa);color:#fff;border:none;box-shadow:0 6px 20px rgba(99,102,241,0.45);cursor:pointer;font-size:20px;display:flex;align-items:center;justify-content:center;z-index:900;transition:transform .15s ease,box-shadow .15s ease}
          .share-fab:hover{transform:scale(1.08);box-shadow:0 8px 24px rgba(99,102,241,0.55)}
          .share-fab.copied{background:#10b981;box-shadow:0 6px 20px rgba(16,185,129,0.45)}
          .copyright{text-align:center;padding:14px 16px;color:#aaa;font-size:12px;margin-top:8px}
        </style>

        <div class="header">
          <button class="header-back" aria-label="Go home" title="홈으로">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5L12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/></svg>
          </button>
          <div class="header-title">📐 수학 그래프</div>
          <img class="header-hits" alt="Hits" src="https://hits.sh/hits.sh/dooboostore.github.io-apps-center-math.svg?style=plastic&amp;"/>
        </div>

        <div class="content">
          <div class="card">
            <div class="card-header"><span class="card-title">📚 개념 선택</span></div>
            <div class="card-body"><div class="tab-group">${tabs}</div></div>
          </div>

          <div class="card">
            <div class="card-header"><span class="card-title">📈 그래프</span></div>
            <div id="math-view"><${meta.el}></${meta.el}></div>
          </div>
        </div>

        <button id="math-share-fab" class="share-fab" title="공유">🔗</button>
        <footer class="copyright">© ${new Date().getFullYear()} dooboostore</footer>
      `;
        }
    };
    __decorate([
        onConnectedBefore,
        innerHtml((c, helper) => helper.$w.document.querySelector('title'), { valueKey: 'titleBody' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:title"]'), 'content', { valueKey: 'ogTitle' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="description"]'), 'content', { valueKey: 'desc' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:description"]'), 'content', { valueKey: 'ogDesc' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:image"]'), 'content', { valueKey: 'ogImage' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:image"]'), 'content', { valueKey: 'twitterImage' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:title"]'), 'content', { valueKey: 'twitterTitle' }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:description"]'), 'content', { valueKey: 'twitterDesc' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MathPage.prototype, "setPageMeta", null);
    __decorate([
        onInitialize,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Router !== "undefined" && Router) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], MathPage.prototype, "onInit", null);
    __decorate([
        onConnectedAfter,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MathPage.prototype, "onAfterConnected", null);
    __decorate([
        addEventListener('.header-back', 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MathPage.prototype, "onBack", null);
    __decorate([
        addEventListener('.tab-concept', 'click', { delegate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Event !== "undefined" && Event) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], MathPage.prototype, "onConceptTab", null);
    __decorate([
        addEventListener('#math-share-fab', 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], MathPage.prototype, "onShareFab", null);
    __decorate([
        onConnectedBodyShadow,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MathPage.prototype, "render", null);
    MathPage = __decorate([
        elementDefine(tagName, { window: w })
    ], MathPage);
    return tagName;
};
